import React from 'react';
import { useSocket } from '../../../context/useSocket';
import styles from '../chat.module.scss';

// Suptilan "Povezivanje..." indikator dok socket nije povezan.
const ConnectionIndicator = () => {
  const { connected } = useSocket();
  if (connected) return null;

  return (
    <span className={styles.connection}>
      <span className={styles.connection__dot} />
      Povezivanje…
    </span>
  );
};

export default ConnectionIndicator;
